// extracted by mini-css-extract-plugin
module.exports = {"slice":"PieSlice_slice__18EGr","sliceContainer":"PieSlice_sliceContainer__1863U","sliceText":"PieSlice_sliceText__1Of3u"};